<div class="px-3">
    <div class="rem-text-default mb-6">
        <div class="flex align-items-center">
    
          <div class="rem-bg-light px-3 py-3 mr-2">
            <i class="pi pi-file font-medium text-xl"></i>
          </div>
          <div>
            <div class="text-2xl font-medium">File Mapping Search</div>
            <div class="text-right mt-2">Manage file mappings</div>
          </div>
          
        </div>
    </div>
  
    <br />
    <div class="flex justify-content-between bottom-padded">
        <div class="flex flex-row gap-3">
            <p-floatLabel>
                <p-autoComplete [(ngModel)]="selectedCreditor" 
                                [suggestions]="filteredItems"  
                                (completeMethod)="filterItems($event)" 
                                field="LongNameWithId" 
                                [dropdown]="true" 
                                placeholder="Select Creditor" 
                                id="creditors">
                   <ng-template let-creditor pTemplate="item">
                    <div class="flex align-items-center justify-content-between flex-1">
                      <div>{{creditor.CompanyName}}</div>
                      <div>{{creditor.CreditorId.replace('creditor/','')}}</div>
                    </div>
                </ng-template>
             </p-autoComplete>
                <!-- 
                 <p-dropdown id="creditors" [options]="creditors"
                            [(ngModel)]="selectedCreditor"
                            optionLabel="LongNameWithId"
                            placeholder="Select Creditor"> 
                </p-dropdown>
                -->
                <label for="creditors">Creditor</label>
            </p-floatLabel>
            <p-floatLabel>
                <input pInputText id="mappingType" [(ngModel)]="searchMappingTypeExpression" placeholder="Type name expression" />
                <label for="mappingType">Mapping Type</label>
            </p-floatLabel>
    
            <remitter-button
                (click)="search()" 
                label='Search Mappings'
                icon='search'
            >     
            </remitter-button>
            
            <remitter-button   
                (click)="create()" 
                label='New Mapping'
                icon='plus'
                severity='info'
            >     
            </remitter-button>
           
        </div>
    </div>
    <div class="mt-3">
        <div *ngIf="!hasTableData && hasClickedSearch" style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                    🚫 No records found for {{ selectedCreditor?.CompanyName }}
        </div>
        <p-table 
            *ngIf="hasTableData"
                 [value]="searchResult" [paginator]="true"
                 [rows]="20"
                 [tableStyle]="{ 'min-width': '50rem' }"
                 [rowsPerPageOptions]="[20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Creditor ID</th>
                    <th>Creditor Company Name</th>
                    <th>File Mapping Type Name</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-mappingSearchResult>
                <tr>
                    <td (click)="edit(mappingSearchResult)">
                        <i pTooltip="File Mapping ID: {{ mappingSearchResult.DataFileMappingId }}"
                        tooltipPosition="right" 
                        class="pi pi-map icon text-xs cursor-pointer"></i>
                    </td>
                    <td (click)="edit(mappingSearchResult)">{{ mappingSearchResult.CreditorId }}</td>
                    <td (click)="edit(mappingSearchResult)">{{ mappingSearchResult.CreditorCompanyName }}</td>
                    <td (click)="edit(mappingSearchResult)">{{ mappingSearchResult.FileMappingTypeName }}</td>
                    <td>
                        <i class="pi pi-trash text-xs cursor-pointer" pTooltip="Delete" tooltipPosition="left" 
                        (click)="deleteMapping(mappingSearchResult)" 
                        ></i>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    
</div>